<template>
  <a-layout>
    <a-layout-content class="py-12">
      <div class="row">
        <img src="@/assets/logo-wheezo-vert.svg" />
      </div>
      <div class="row">
        <div class="px-4" style="width: 750px">
          <a-card class="my-12 text-center" :bordered="false">
            <h3 class="mb-10">This page doesn't exist.</h3>
            <router-link to="/">
              <a-button type="primary" size="large" html-type="submit">
                Return to Home
              </a-button>
            </router-link>
          </a-card>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer class="caption text-center">
      &copy; 2019 Respiri Limited. All rights reserved.
    </a-layout-footer>
  </a-layout>
</template>
<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ErrorPage extends Vue {}
</script>
<style lang="postcss" scoped>
.row {
  @apply flex justify-center;
}
</style>
